import { Component, computed, inject, input, output } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { SelfserviceToggleComponent } from "../../../../selfservice/selfservice-toggle/selfservice-toggle";
import { AuthService } from "../../../../../services/AuthService";
import { EnabledPipe } from "../../../../../helpers/enabledpipe/enabledpipe";
import { Row } from "../../tabbed-detail-container";

@Component({
  selector: "configuration-details",
  templateUrl: "configuration-details.html",
  styleUrls: [],
  imports: [AngularSvgIconModule, EnabledPipe, MatTooltipModule, SelfserviceToggleComponent, TranslateModule],
})
export class ConfigurationDetails {
  protected auth = inject(AuthService);

  readonly configurationDetails = input.required<{ title: string; rows: Row[] }>();
  readonly firewallEnabled = input.required<boolean>();
  readonly isInfrastructureDelegate = input.required<boolean>();

  protected title = computed(() => this.configurationDetails().title);
  protected rows = computed(() => this.configurationDetails().rows);

  protected clicked = output<string>();

  protected onBfdSelfService = () => this.clicked.emit("bfd");
}
